//Функции, описывающие порядок выполнения задач

//Строгий порядок

function StrongCont(ctheme, task, ruleset){
    let currentList = ruleset.theme[ctheme];
    let i = currentList.indexOf(task);
    if(i === currentList.length - 1) return [];
    else return [currentList[i+1]];
}

export default StrongCont;